<div *ngIf="showLanguageSelector" class="language-selector">
  <button *ngFor="let lang of languages" (click)="changeLanguage(lang.code)" [class.active]="isCurrentLanguage(lang.code)" title="{{lang.name}}">
    {{lang.name}}
  </button>
</div>